<template>
  <div id="content" class="crpg-o-private-cruising-content entertainment">
    <div
      id="detail"
      class="crpg-o-private-cruising-content__detail entertainment_1"
    >
      <MoleculesCommonContentTitleRed :title="content.title" />

      <div class="pic_1">
        <img :src="contentTopImage" alt="" />
      </div>
      <div class="doc">
        <p class="newline">{{ content.topText }}</p>
      </div>
      <div id="cruiser">
        <div class="subtitle">クルーザーの種類</div>
        <ul>
          <li
            class="cruiser"
            v-for="item in content.culuisingDate"
            :key="item.id"
          >
            <MoleculesPrivateCruisingCruiser
              :image="item.image"
              :culusingName="item.culusingName"
              :marina="item.marina"
              :hull="item.hull"
              :fullLength="item.fullLength"
              :capacity="item.capacity"
              :equipment="item.equipment"
            />
          </li>
        </ul>
      </div>
      <div class="gallery">
        Photo Gallery
        <MoleculesPrivateCruisingPhotoGallery :image="obj" />
      </div>
      <div id="spot">
        <div class="subtitle">東京湾 主な見どころ</div>
        <ul>
          <li v-for="item in content.bayDate" :key="item.id">
            <MoleculesPrivateCruisingBay
              :image="item.image"
              :title="item.title"
              :content="item.content"
            />
          </li>
        </ul>
      </div>
      <!--
      <div id="access">
        <div class="subtitle">乗下船場所</div>
        <ul>
          <li v-for="item in content.DisembarkingDate" :key="item.id">
            <MoleculesPrivateCruisingAccess
              :image="item.image"
              :mapName="item.mapName"
              :mapAdress="item.mapAdress"
              :mapTel="item.mapTel"
            />
          </li>
        </ul>
      </div>
      -->
      <br />
      <MoleculesPrivateCruisingCuruisingInfo
        :reserv="content.reserv"
        :guarantee="content.guarantee"
        :cautionTitleText="content.cautionTitleText"
        :caution="content.caution"
      />
    </div>
  </div>
</template>

<script>
import MoleculesCommonContentTitleRed from "@/components/molecules/privateCruising/ContentTitleRed.vue";
import MoleculesPrivateCruisingBay from "@/components/molecules/privateCruising/Bay.vue";
import MoleculesPrivateCruisingCruiser from "@/components/molecules/privateCruising/Cruiser.vue";
import MoleculesPrivateCruisingCuruisingInfo from "@/components/molecules/privateCruising/CruisingInfo.vue";
//import MoleculesPrivateCruisingAccess from "@/components/molecules/privateCruising/Access.vue";
import MoleculesPrivateCruisingPhotoGallery from "@/components/molecules/privateCruising/PhotoGallery.vue";

import text from "@/assets/txt/private_cruising.json";
var textDate = text;
export default {
  name: "PgPrivateCruising",
  components: {
    MoleculesCommonContentTitleRed,
    MoleculesPrivateCruisingBay,
    MoleculesPrivateCruisingCruiser,
    MoleculesPrivateCruisingPhotoGallery,
    MoleculesPrivateCruisingCuruisingInfo,
    //    MoleculesPrivateCruisingAccess,
  },
  data() {
    return {
      content: textDate,
      contentTopImage: require("@/assets/img/cruising_top.jpg"),
      obj: [
        "pic_4.jpg",
        "pic_5.jpg",
        "pic_6.jpg",
        "pic_7.jpg",
        "pic_8.jpg",
        "pic_9.jpg",
        "pic_18.jpg",
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/privateCruising/privateCruisingContent.scss";
</style>
